
export function getMajorVersion(version: number) {
    return Math.floor(version)
}
